<template>
  <div class="menu-wrapper">
    <template
      v-for="(item, index) in sideBarMenu"
      v-if="!item.hidden && item.children"
    >
      <router-link
        v-if="
          hasOneShowingChildren(item.children) &&
            !item.children[0].children &&
            !item.alwaysShow
        "
        :to="item.path + '/' + item.children[0].path"
        :key="item.children[0].name"
      >
        <el-menu-item
          :index="item.index"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <i :class="item.children[0].meta.icon"></i>
          <span
            v-if="item.children[0].meta && item.children[0].meta.title"
            slot="title"
            >{{ item.children[0].meta.title }}</span
          >
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.index" :key="item.name">
        <template slot="title">
          <!-- <svg-icon
            v-if="item.meta && item.meta.icon"
            :icon-class="item.meta.icon"
          ></svg-icon> -->
          <i :class="item.meta.icon"></i>
          <span v-if="item.meta && item.meta.title" slot="title">{{
            item.meta.title
          }}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item
            :is-nest="true"
            class="nest-menu"
            v-if="child.children && child.children.length > 0"
            :routes="[child]"
            :key="child.path"
          ></sidebar-item>

          <router-link
            v-else
            :to="item.path + '/' + child.path"
            :key="child.name"
          >
            <el-menu-item :index="child.index">
              <i :class="child.meta.icon"></i>
              <span v-if="child.meta && child.meta.title" slot="title">{{
                child.meta.title
              }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
import { setSupport, getSupport, setCookie, getCookie } from "@/utils/support";
export default {
  name: "SidebarItem",
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },

  // 权限设置角色：超级管理员（全部模块）、审核商品（不显示促销活动、账号设置）、创建促销（不显示审核商品操作、账号设置）
  //   ADMIN(0, "超级管理员"),
  // VERIFY_GOODS(1, "审核商品"),
  // CREATE_PROMOTION(2, "创建活动");
  created() {
    const _copy = JSON.parse(JSON.stringify(this.routes));
    if (getCookie("role") === "1") {
      _copy[3].children.splice(0, 1);
      _copy.splice(4, 1);
    }
    if (getCookie("role") === "2") {
      _copy.splice(4, 1);
    }
    this.sideBarMenu = _copy;
  },
  data: () => {
    return {
      accountType: "merchant", // merchant  maintanence
      sideBarMenu: []
    };
  },

  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden;
      });
      if (showingChildren.length === 1) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss">
.el-menu-item {
  height: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  line-height: 40px;
}

.sidebar-container {
  width: 146px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue